export const formatLabelWithPercent = (value: string | number): string => `${value}%`;
